import RagomicsWebsite from './components/RagomicsWebsite';
import './index.css';

function App() {
  return (
    <div className="App">
      <RagomicsWebsite />
    </div>
  );
}

export default App;